import { State } from '@/types/State';
import {
    computed, reactive, watch
} from 'vue';
import _ from 'lodash';
import { NestedCategory, transformNestedToFlatMetrics } from '@/components/MetricsConfigurationPage/getSavedMetricsConfig';

export const state: State = reactive({
    categories: [],
    savedCategories: [],
    isDirty: false,
    dirtyMetrics: [],
    workstreamMetricsEnabled: false,
    getWorkstreamMetrics: computed(() => {
        return state.categories.find((category) => category.headerName === 'Workstream Metrics');
    }),
    toasts: []
});

watch(() => state.categories, (_oldValue, newValue) => {
    state.isDirty = !(_.isEqual(newValue, state.savedCategories)) && newValue.length > 0;
    const onScreenMetrics = transformNestedToFlatMetrics({ metricsConfig: state.categories as NestedCategory[] });
    const originalMetrics = transformNestedToFlatMetrics({ metricsConfig: state.savedCategories as NestedCategory[] });
    state.dirtyMetrics = onScreenMetrics.filter((obj1) => {
        const obj2 = originalMetrics.find((obj2) => `${obj2.category}.${obj2.subcategory}.${obj2.id}` === `${obj1.category}.${obj1.subcategory}.${obj1.id}`);
        return obj2 &&
            (
                // Treat as boolean as if it's undefined or empty string, we'll treat as false.
                (obj1.customName ?? '') !== (obj2.customName ?? '') ||
                Boolean(obj1.isEnabled) !== Boolean(obj2.isEnabled)
            );
    });
}, { deep: true });